import { reportError } from "./errorHelper";

export const removeTags = (str) => {
  if (typeof str === "undefined" || str === null || str === "") return false;
  else str = str.toString();
  return str.replace(/(<([^>]+)>)/gi, "");
};

export const priceFormatFunc = (str) => {
  try {
    let stringPrice = str; 
    // Convert string to a numeric value
    let numericPrice = parseFloat(stringPrice.replace('$', '').replace(',', ''));
    // Check if the numeric value is an integer (has no decimal part)
    if (Number.isInteger(numericPrice)) {
      // Format the number without decimal places and add commas for thousands
      str = "$" + numericPrice.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      // Format the number with two decimal places and add commas for thousands
      str = "$" + numericPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return str;
  } catch (error) {
    // error handling
    reportError("Error occurred while formatting price");
    reportError(error);
    return str; // Return the original string in case of an error
  }
 }